import Bowser from "bowser";
import { default as i18n } from "./i18n.json";

function getMessage(key) {
    var lang = document.documentElement.lang;
    var messages = (i18n[lang] || i18n.en);
    if (messages && messages[key]) {
        return messages[key];
    } else {
        return "missing resource: " + key;
    }
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArr = decodedCookie.split(';');
    for (var i = 0; i < cookieArr.length; i++) {
        var cookie = cookieArr[i];
        while (cookie.charAt(0) == ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) == 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return "";
}

function checkBrowser() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    console.log("current browser: " + JSON.stringify(browser.getBrowser()));
    var invalidBrowser = browser.satisfies({
        "internet explorer": "<9999" // not any version of internet explorer
    });
    if (window.zebDshDisableBrowserCheck) {
        console.log("browser is unsupported: " + invalidBrowser);
        console.log("ignoring browser check");
        invalidBrowser = false;
    }
    if (!invalidBrowser) {
        return true;
    } else {
        const supportMessage = getMessage("message browser unsupported");
        const updateMessage = getMessage("message browser needs update");
        const closeTooltip = getMessage("tooltip button close browser unsupported");
        const cookieName = "zebdshIgnoreUnsupportedBrowser";
        var cookieValue = getCookie(cookieName);
        if (cookieValue == "true") {
            return false;
        }
        var insertContentHere = document.getElementById("zebdsh-browserUnsupported");
        if (insertContentHere) {
            insertContentHere.innerHTML = ('<div class="vertical-center"><h1>' +
                supportMessage +
                "</h1>" +
                updateMessage +
                '<p class="right"><a href="#" id="zebdsh-browserUnsupportedButtonClose" title="' +
                closeTooltip +
                '">&times;</a></p></div>');
            insertContentHere.style.display = "table";
            var buttonClose = document.getElementById("zebdsh-browserUnsupportedButtonClose");
            if (buttonClose) {
                buttonClose.addEventListener("mousedown", function () {
                    document.cookie = cookieName + "=true;path=/";
                    insertContentHere.style.display = "none";
                    return false;
                });
            }
        }
        return false;
    }
}

window.addEventListener("load", function () {
    checkBrowser();
});

(function (drupalSettings) {
    if ("zebDsh" in drupalSettings && "disableBrowserCheck" in drupalSettings.zebDsh) {
        console.log("browser check disabled");
        window.zebDshDisableBrowserCheck = true;
    }
})(drupalSettings);
